
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oferty-pracy",
      function () {
        return require("private-next-pages/oferty-pracy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oferty-pracy"])
      });
    }
  